import { Banner, Button, Text } from '@dixa/lib-shared-habla';

import styles from '../composeEmailModal.module.scss';
import type { FormValues } from '../composeEmailModal.types';

const linkTypeLabelMap = (
  parentConversation: number,
): Record<string, string> => ({
  email_forward: `Compose a transcript of conversation #${parentConversation}`,
  follow_up: `Follow-up on conversation #${parentConversation}`,
  side: `Compose a side conversation to #${parentConversation}`,
});

type ComposeEmailLinkedBannerProps = {
  linkType: FormValues['linkType'];
  parentConversation: number;
  linkedDataLoading: boolean;
  onCopyPaste: () => void;
};

export function ComposeEmailLinkedBanner({
  linkType,
  parentConversation,
  linkedDataLoading,
  onCopyPaste,
}: ComposeEmailLinkedBannerProps): JSX.Element {
  return (
    <Banner
      className={styles.banner}
      variant="info"
      icon={null}
      description={
        <Text.Paragraph variant="1">
          {linkTypeLabelMap(parentConversation)[linkType ?? 'side']}
        </Text.Paragraph>
      }
      actionSlot={
        !linkType || linkType === 'side' ? (
          <Button
            type="button"
            variant="secondary"
            onClick={onCopyPaste}
            isLoading={linkedDataLoading}
            disabled={linkedDataLoading}
          >
            Insert transcript
          </Button>
        ) : undefined
      }
    />
  );
}
